export interface DeclarationsOverview {
	[key: string]: Declarations | Anual | undefined;
	platec?: Declarations;
	resico?: Declarations;
	business?: Declarations;
	anual: Anual;
}

export interface Anual {
	presented: AnnualPresented[];
	pending: AnualPending[];
}

export interface AnnualPresented {
	id: number;
	year: string;
	presented_at: string;
	url: string;
	payment_date: string;
}

export interface AnualPending {
	year: string;
	days_late: number;
	presentation_date: string;
}

export interface Declarations {
	presented: Presented[];
	pending: Pending[];
}

export interface Pending {
	month: string;
	year: string;
	days_late: number;
}

export interface Presented {
	month: string;
	year: string;
	presented_at: string;
	url: string;
}

export interface DeclarationDetail {
	regime?: string;
	id: number;
	declarationType: string;
	year: number;
	month: number;
	presentedAt: string;
	url: string;
	amount: number;
	paid?: boolean;
	presentedBy?: 'Heru' | 'user';
}

export interface ApprovalDeclaration {
	id: number;
	fft_id: number;
	fft_precalculate_id: number;
	user_id: number;
	period: string;
	status: string;
	reason_denied: null;
	accountant_id: null;
	accountant_notes: null;
	created_at: Date;
	updated_at: Date;
	denied_at: null;
	edited_at: null;
	limit_at: Date;
	payment_method: string;
	detail: Detail;
	fft_status: string;
}

export interface Detail {
	type: string;
	year: string;
	month: string;
	userId: number;
	additionalInformation: AdditionalInformation;
	totalBalance: number;
}

export interface AdditionalInformation {
	ISR: ISR[];
	IVA: Iva;
	fft_id: number;
	period: string;
	user_id: number;
	paymentMethod: string;
}

export interface ISR {
	active: boolean;
	driver?: Delivery;
	delivery?: Delivery;
	serviceType: string;
	tax_retained: number;
	cash?: number;
	platform?: number;
	seller?: Delivery;
	services?: Delivery;
}

export interface Delivery {
	cash: number;
	platform: number;
}

export interface Iva {
	cash: number;
	platform: number;
	deductions: number;
	serviceTypes: any[];
	tax_retained: number;
	lastPeriodBalance: number;
}
export interface ApprovalDeclarationDetail {
	income: Income[];
	expense: Expense[];
	deductibles: Deductible[];
	precalculate_details: Detail[];
}

export interface Deductible {
	based_deductibles: BasedDeductibles;
}

export interface BasedDeductibles {
	deductions: Deductions[];
	not_deductions: NotDeduction[];
	totalDeductible: number;
}

export interface NotDeduction {
	id: number;
	tax: number;
	type: string;
	uuid: string;
	total: number;
	usage: string;
	user_id: number;
	subtotal: number;
	issued_at: string;
	isser_name: string;
	tax_amount: number;
	description: string;
	total_taxed: null;
	payment_type: string;
	related_uuid: null;
	receiver_name: string;
	payment_amount: null;
	payment_method: string;
	items: Item[];
}

export interface Expense {
	total_expense: TotalExpense;
}

export interface TotalExpense {
	total: number;
	expenses: NotDeduction[];
}

export interface Income {
	platec_income: PlatecIncome;
}

export interface PlatecIncome {
	invoiceIncome: InvoiceIncome;
	retentionIncome: RetentionIncome;
}

export interface InvoiceIncome {
	total: number;
	invoices: any[];
}

export interface RetentionIncome {
	total: number;
	incomeInfo: any[];
	retentions: Retentions[];
}
export interface Retentions {
	id: number;
	uuid: string;
	taxes: Tax[];
	pdf_url: null;
	xml_url: string;
	issued_at: string;
	period_to: string;
	issuer_code: string;
	issuer_name: string;
	period_from: string;
	service_type: string;
	total_taxable_amount: number;
	total_retained_amount: number;
}

export interface Tax {
	id: number;
	tax_type: string;
	base_amount: number;
	payment_type: string;
	retained_amount: number;
}
export interface Deductions {
	id: number;
	tax: number;
	type: string;
	uuid: string;
	total: number;
	usage: string;
	user_id: number;
	subtotal: number;
	issued_at: string;
	isser_name: string;
	tax_amount: number;
	description: string;
	total_taxed: null;
	payment_type: string;
	related_uuid: null;
	receiver_name: string;
	payment_amount: null;
	payment_method: string;
	items: Item[];
}

export interface Item {
	id: number;
	identification_number: string;
	product_identification_description: string;
	description: string;
	unit_amount: number;
	unit_code: string;
	quantity: number;
	discount_amount: null;
	tax_type: string;
	tax_rate: number;
	tax_amount: number;
	total_amount: number;
	invoice_id: number;
	tax_factor_type: null;
	created_at: Date;
	updated_at: Date;
	is_deductible: boolean;
	reason: string;
}

export interface ApprovalDeclarationDetailFFT {
	id: number;
	fft_id: number;
	fft_precalculate_id: number;
	user_id: number;
	period: string;
	status: string;
	reason_denied: any[];
	accountant_id: null;
	accountant_notes: any[];
	created_at: Date;
	updated_at: Date;
	denied_at: null;
	edited_at: null;
	limit_at: Date;
}

// Declarations Redesign

export enum DeclarationV3DeclarationType {
	NORMAL = 'NORMAL',
	COMPLEMENTARY = 'COMPLEMENTARY',
}

export enum DeclarationV3Type {
	platec = 'platec',
	resico = 'resico',
	annual = 'annual',
}

export enum DeclarationV3Status {
	PENDING = 'PENDING',
	IN_REVIEW = 'IN_REVIEW',
	READY_FOR_APPROVAL = 'READY_FOR_APPROVAL',
	PRESENTED = 'PRESENTED',
	PRESENTED_PENDING_PAYMENT = 'PRESENTED_PENDING_PAYMENT',
	ACQUIRED = 'ACQUIRED',
	PREVIEW = 'PREVIEW',
	IN_PROGRESS = 'IN_PROGRESS',
	CURRENT_PERIOD = 'CURRENT_PERIOD',
	FUTURE = 'FUTURE',
	NOT_STARTED_ACTIVITY = 'NOT_STARTED_ACTIVITY',
	INFORMATIVE = 'INFORMATIVE',
}

// Interfaces para ApprovalFlow
export interface IncomeByService {
	other_services: number;
	transport_service: number;
	accommodation_service: number;
	food_delivery_service: number;
	goods_commerce_service: number;
	goods_delivery_service: number;
}

export interface WithholdingsByRate {
	rate_1_percent: number;
	rate_4_percent: number;
	rate_2_1_percent: number;
}

export interface WithholdingsByService {
	other_services: number;
	transport_service: number;
	accommodation_service: number;
	food_delivery_service: number;
	goods_commerce_service: number;
	goods_delivery_service: number;
}

export interface ISRDetails {
	income_by_rate: WithholdingsByRate;
	income_by_service: IncomeByService;
	withholdings_by_rate: WithholdingsByRate;
	income_by_service_total: number;
	withholdings_by_service: WithholdingsByService;
	withholdings_by_service_total: number;
}

export interface TaxableIncome {
	iva_charged: number;
	iva_withheld: number;
	iva_taxable_income: number;
}

export interface IVADetails {
	deductions: number;
	taxable_income: TaxableIncome;
	taxable_income_total: number;
}

export interface ApprovalFlowDetail {
	period: string;
	regime: string;
	iva_charged: number;
	regime_name: string;
	isr_retained: number;
	iva_withheld: number;
	total_a_pagar: number;
	iva_deductions: number;
	isr_total_to_pay: number;
	iva_total_to_pay: number;
	income_by_service: IncomeByService;
	incomes_accumulated: number;
	cumulative_positive_balance: number;
	previous_period_favorable_balance: number;
}

export interface ApprovalFlow {
	period: string;
	regime: string;
	status: string;
	detail: ApprovalFlowDetail;
}

export interface Precalculate {
	period: string;
	regime: string;
	isr_details: ISRDetails;
	isr_total_to_pay: number;
	iva_details: IVADetails;
	iva_total_to_pay: number;
	cumulative_positive_balance: number;
	period_total_to_pay: number;
	updated_at: string;
}

export interface ApprovalFlowMonthInfo {
	year: string;
	month: string;
	approvalFlow: ApprovalFlow;
	precalculate: Precalculate;
}

export interface DeclarationV3Income {
	total: number;
	[key: string]: number;
}

export interface AnnualPrecalculation {
	year: number;
	salarios_details: any;
	plataformas_details: any;
	actividad_empresarial_details: any;
	arrendamiento_details: any;
	intereses_details: any;
	deducciones_personales_details: any;
	determinacion_isr: {
		isr_retenido: number;
		tarifa_anual: {
			excedente: number;
			cuota_fija: number;
			isr_tarifa: number;
			limite_inferior: number;
			porcentaje_excedente: number;
		};
		base_gravable: number;
		resultado_isr: number;
		subsidio_empleo: number;
		pagos_provisionales: number;
		ingresos_acumulables: number;
		deducciones_personales: number;
		deducciones_personales_detalle: {
			uma_anual: number;
			monto_visor: number;
			tope_15_pct: number;
			tope_5_umas: number;
		};
	};
	total_ingresos_acumulables: number;
	total_deducciones_personales: number;
	base_gravable: number;
	isr_tarifa: number;
	isr_retenido_total: number;
	isr_resultado: number;
}

export interface AnnualVisorDeduction {
	uuid: string;
	amount: number;
	deduction_type: string;
	description: string;
	total_validated: string;
	month: number;
	year: number;
}

export type AnnualResult = 'TO_PAY' | 'IN_FAVOR' | 'ZERO';

export interface AnnualDeclarationV2 {
	income: number;
	year: number;
	isAcquired: boolean;
	needsRenewal: boolean;
	hasFFTs: boolean;
	type: 'annual';
	status: DeclarationV3Status;
	annual_visor_deductions: {
		total: number;
		total_validated: string | null;
		items: AnnualVisorDeduction[];
	};
	precalculation: AnnualPrecalculation | null;
	previewUrl?: string | null;
	approvalStatus?: 'pending' | 'approved' | 'denied' | null;
	result?: AnnualResult;
	resultAmount?: number;
	presentedDeclarations?: PresentedDeclaration[];
	paid?: boolean;
}

export interface DeclarationV3 {
	month?: number;
	year: number;
	income?: DeclarationV3Income | number;
	isAcquired?: boolean;
	hasFFTs?: boolean;
	type?: DeclarationV3Type;
	regimes?: string[];
	status?: DeclarationV3Status;
	paid?: boolean;
	acquiredSource?: string;
	presentedDeclarations?: PresentedDeclaration[];
	userHasActiveManualDeclarations?: boolean;
	approvalFlowMonthInfo?: ApprovalFlowMonthInfo;
}

export interface AnnualPayment {
	paymentUrl: string;
	paymentDate: string;
	paidAmount: number;
	captureLine: string;
	operationNumber: string;
	paymentKey: string;
}

export interface AnnualPartiality {
	partialityNumber: number;
	totalAmountToPay: number;
	untilDate: string;
	captureLine: string;
	url: string;
	operationNumber: string;
	emisionDate: string;
	paid: boolean;
	paymentDate: string | null;
	paidAmount: number | null;
}

export interface PresentedDeclaration {
	month: number;
	year: number;
	presentedAt: string;
	url: string;
	presentationUrl?: string;
	detailUrl?: string;
	paymentUrl?: string | null;
	amountToPay: number;
	declarationType: string;
	hasFFTs: boolean;
	income: number;
	isAcquired: boolean;
	operationNumber: string;
	presentedBy: string;
	status: string;
	type: string;
	captureLine?: string;
	taxInFavor?: number | null;
	payments?: AnnualPayment[];
	partialities?: AnnualPartiality[];
	validUntil?: string;
}
